export const categoryMixin = {
    methods: {
        getCategoryHref(category) {
            return category.OverrideUrl || `/browse/${category.SanitizedPath}`;
        }
    }
}